import { CouponActRelation } from '../../types';
import { Activity } from './activity';
/**
 * 与券有关的活动
 */
export class CouponActivity extends Activity {
    constructor(couponActRelation) {
        super();
        /** 券和活动对应关系，默认为单券对应多个活动 */
        this.couponActRelation = CouponActRelation.oneForMore;
        /** 该活动下的券列表 + 券静态信息 */
        this.couponList = [];
        /** 用户的在该活动下的券列表 */
        // TODO: 要弃用
        this.userCouponList = [];
        /** 券和活动对应关系 */
        if (couponActRelation)
            this.couponActRelation = couponActRelation;
    }
}
